declare function require(name: string);

declare global {
  // const _: _;
  const d3: d3;
  const zxcvbn: zxcvbn;
  const LC_API: any;
  const PouchDB: pouchDB;
  const L: L;
}

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as d3 from 'd3';
import * as Highcharts from 'highcharts';
import hMore from 'highcharts/highcharts-more';
import hBrokenAxis from 'highcharts/modules/broken-axis';
// import hExporting from 'highcharts/modules/exporting'; //not supported by highcharts 8.2.2 ( not used anywhere in either app either )
import hNoDataToDisplay from 'highcharts/modules/no-data-to-display';
import hSankey from 'highcharts/modules/sankey';
import hSolidGauge from 'highcharts/modules/solid-gauge';
import * as L from 'leaflet';
import * as _ from 'lodash';
import * as moment from 'moment';
import 'moment-timezone';
// only 'pouchdb' doesn't work, issue with global variable
import * as pouchDB from 'pouchdb/dist/pouchdb';
import * as zxcvbn from 'zxcvbn';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import bullet from 'highcharts/modules/bullet.js';

import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/python/python';
import 'codemirror/mode/markdown/markdown';


bullet(Highcharts);
hMore(Highcharts);
hSankey(Highcharts);
// hExporting(Highcharts);
hSolidGauge(Highcharts);
hNoDataToDisplay(Highcharts);
hBrokenAxis(Highcharts);

window['Highcharts'] = Highcharts;

(window as any).global = window;
(window as any).process = {};
(window as any).process.nextTick = setTimeout;

require('leaflet-curve');
require('leaflet-arc');
require('leaflet-polylinedecorator');
require('leaflet.markercluster');
require('leaflet.tilelayer.pouchdbcached');
require('leaflet-easybutton');

window['L'] = L;
window['d3'] = d3;
window['moment'] = moment;
window['zxcvbn'] = zxcvbn;
(window as any).PouchDB = pouchDB;
//------------------------------------------------------------------------

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
